import React, {Component} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import NavBar from './ui/components/navbar'
import Home from './ui/screen/home';
import Login from './ui/screen/login';
import AdminTool from './ui/screen/adminTool';
import RoomDetail from './ui/screen/roomDetail';


class App extends Component {
  render() {
    return(
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route exact path='/' component={Home}/>
            <Route path='/login' component={Login}/>
            <Route path='/adminTool' component={AdminTool}/>
            <Route path='/roomDetail/:room_id' component={RoomDetail}/>
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

export default App;
